import React from 'react';
import { Nav, Navbar, MenuItem } from 'react-bootstrap';
import ContactInfo from '../ContactInfo';
import * as actionCreators from '../../../store/actions/login';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import SubNavigation from '../../SubNavigation/SubNavigation';
import UserProfileTitle from './UserProfileTitle';

const NavMenu = ({ onNavBarSelect, login, app, config, hideBrand, onWebChatButtonClick }) => {

  var isChatBotEnabled = config && config.ChatBot_IsEnabled && config.ChatBot_IsEnabled.toLowerCase() === 'true';

  // const documentMenu = props.selectedAccount
  //     ? (
  //         <LinkContainer to="/documents">
  //             <NavItem>
  //                 Documents
  //             </NavItem>
  //         </LinkContainer>
  //     )
  //     : null;



  const userName = login.CurrentUser
    ? login.CurrentUser.firstName +
    ' ' +
    (login.CurrentUser.lastName || '')
    : '';

  const disableIt = app ? app.width <= 980 : false;
  //  console.log(props.app.width, 'app.width', disableIt);
  const brand = hideBrand ? null : (
    <Navbar.Brand>MyAccount Manager&trade;</Navbar.Brand>
  );
  return (
    <Navbar
      id="header"
      fixedTop
      fluid
      collapseOnSelect
      onSelect={onNavBarSelect}
    >
      <Navbar.Header>
        {brand}
        <Navbar.Toggle />

        <span className="header-icon-links">
          {login.CurrentUser && isChatBotEnabled ? <a
            href="/#"
            onClick={onWebChatButtonClick}
            className="header-icon-link"
            title="Chat Now"
          >
            <i className="fas fa-comment-smile"></i>
          </a> : null}
          <a
            href="tel:877-868-3800"
            className="header-icon-link"
            title="Call Us: (877) 868-3800 "
          >
            <i className="fas fa-phone"></i>
          </a>
          <a
            href="mailto:info@timepayment.com?cc=infohub@timepayment.com"
            className="header-icon-link"
            title="Email Us: info@timepayment.com"
          >
            <i className="fas fa-envelope"></i>
          </a>
        </span>
      </Navbar.Header>
      <Navbar.Collapse className="no-transition">
        <Nav className="main-nav">
          <SubNavigation
            region="accounts"
            title="Account"
            comp="menu"
          ></SubNavigation>
          <SubNavigation
            region="billing"
            title="Billing"
            comp="menu"
          ></SubNavigation>
        </Nav>

        <Nav pullRight>
          <ContactInfo showWebChat={login && login.CurrentUser} onWebChatButtonClick={onWebChatButtonClick} />

          <SubNavigation
            region="profile"
            title={<UserProfileTitle userName={userName} />}
            comp="menu"
            className="profile-menu"
            pullRight
            eventKey={3}
            disableMouseOver={disableIt}
            additionalItems={
              <React.Fragment>
                <MenuItem divider />
                <MenuItem
                  eventKey={'logout'}
                  key={'logout'}
                  onSelect={onNavBarSelect}
                >
                  Logout
                </MenuItem>
              </React.Fragment>
            }
          ></SubNavigation>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

const mapStateToProps = state => ({
  config: state?.app?.config,
  login: state.login,
  account: state.account ? state.account : null,
  app: state.app,
  selectedAccount: state.account ? state.account.account : null
});
export default connect(
  mapStateToProps,
  dispatch => bindActionCreators(actionCreators, dispatch),
  null,
  { pure: false }
)(NavMenu);
